"use client";
import * as React from "react";

import Image from "next/image";
import { Icons } from "@/app/assets/shared";

interface FileUploadProps {
  title?: string;
  variant?: "light" | "dark";
  // eslint-disable-next-line no-unused-vars
  onUploadSuccess?: (_fileInfo: any) => void;
}

export const FileUpload: React.FC<FileUploadProps> = ({
  title = "Add File",
  variant = "light",
  onUploadSuccess,
}) => {
  const [selectedFile, setSelectedFile] = React.useState<File | null>(null);
  const [uploading, setUploading] = React.useState(false);
  const [uploadError, setUploadError] = React.useState<string | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setSelectedFile(file);
    setUploadError(null);

    if (file) {
      onUploadSuccess?.(file);
      setUploading(false)
    }
  };

  return (
    <label
      className={`flex gap-2 justify-center items-center py-2.5 px-5 text-base tracking-normal rounded-[80px] cursor-pointer border-2 border-dashed transition-colors ${variant === "dark"
          ? "bg-white/5 border-white/20 text-white hover:bg-white/10"
          : "bg-[#fefefe] border-[#cbd5e1] text-[#2563eb] hover:bg-blue-50"
        }`}
    >
      <input
        type="file"
        className="hidden"
        onChange={handleFileChange}
        disabled={uploading}
      />

      {/* Circular Icon Container */}
      <div
        className={`flex items-center justify-center w-8 h-8 rounded-full ${variant === "dark" ? "bg-white/20" : "bg-[#2563eb]"
          }`}
      >
        <Image
          src={Icons?.uploadPlus}
          width={18}
          height={18}
          className={`aspect-square ${variant === "dark"
              ? "grayscale brightness-[100]"
              : "brightness-0 invert"
            }`}
          alt="Upload icon"
          sizes="(max-width: 1024px) 100vw, 50vw"
        />
      </div>

      <span className="font-medium">
        {uploading ? "Uploading..." : selectedFile ? selectedFile.name : title}
      </span>

      {uploadError && (
        <span className="text-red-500 ml-2 text-xs">{uploadError}</span>
      )}
    </label>
  );
};
